/**
 * Catalogue partenaires — données enrichies
 *
 * Structure identique à ce que renvoient les vraies APIs :
 *   Zalando Partner API, ASOS Affiliate, Farfetch Platform, etc.
 *
 * En production : remplacer par des appels API réels
 * Exemple Zalando : GET /api/catalog/articles?category=dress&limit=20
 */

/* ─── Partenaires avec infos branding ───────────────────────── */
export const PARTNERS_INFO = {
  // ═══ Partenaires Premium (CJ Affiliate) ═══
  // Bijouterie / accessoires haut de gamme avec commission directe
  tous:         { name: 'TOUS',          color: '#0A0A0A', bg: '#FAFAFA', logo: '🐻', delivery: '4–7 j', freeFrom: 99,    returns: 30, premium: true },
  iqueens:      { name: 'iQueens',       color: '#C8A560', bg: '#FBF7EE', logo: '👑', delivery: '2–5 j', freeFrom: 0,     returns: 14, premium: true },
  cashmere:     { name: 'Cashmere Boutique', color: '#8B6F47', bg: '#F5EEE0', logo: '🧶', delivery: '3–7 j', freeFrom: 200, returns: 30, premium: true },

  // ═══ Partenaires Premium (Awin / Rakuten / Tradedoubler) — multi-marques homme + femme ═══
  // v1.12.856 — DRESTIGE : multi-marques luxe (Awin 13% commission)
  // v1.12.877 — TAMARIS : chaussures + accessoires F (Tradedoubler 6% commission)
  tamaris:      { name: 'Tamaris',       color: '#6B2E2E', bg: '#FBF4F0', logo: '👠', delivery: '4–5 j', freeFrom: 39,  returns: 30, premium: true },
  // v1.12.944 — DESIGUAL : prêt-à-porter coloré Homme + Femme (Tradedoubler 7,70% commission)
  desigual:     { name: 'Desigual',      color: '#E2231A', bg: '#FCEFEC', logo: '👗', delivery: '3–6 j', freeFrom: 50,  returns: 30, premium: true },
  drestige:     { name: 'DRESTIGE',      color: '#0E0C0A', bg: '#FAF8F4', logo: '👔', delivery: '3–6 j', freeFrom: 200, returns: 14, premium: true },
  suit_negozi:  { name: 'Suit Negozi',   color: '#1A1814', bg: '#F8F5F0', logo: '🤵', delivery: '3–7 j', freeFrom: 0,   returns: 14, premium: true },
  ann_demeulemeester: { name: 'Ann Demeulemeester', color: '#000', bg: '#F5F5F5', logo: '◾', delivery: '5–10 j', freeFrom: 0, returns: 14, premium: true },
  coutr:        { name: 'COUTR',         color: '#1A1A1A', bg: '#F5F5F5', logo: '🇺🇸', delivery: '5–12 j', freeFrom: 0,  returns: 30, premium: true },

  // ═══ Partenaires standards ═══
  zalando:      { name: 'Zalando',       color: '#FF6900', bg: '#FFF5EE', logo: '🟠', delivery: '2–4 j', freeFrom: 24.90, returns: 100 },
  asos:         { name: 'ASOS',          color: '#000000', bg: '#F5F5F5', logo: '⬛', delivery: '3–5 j', freeFrom: 0,     returns: 28  },
  net_a_porter: { name: 'Net-a-Porter',  color: '#1B1B1B', bg: '#F8F8F8', logo: '◼️', delivery: '1–2 j', freeFrom: 150,   returns: 14  },
  farfetch:     { name: 'Farfetch',      color: '#3D3D3D', bg: '#F5F5F5', logo: '🔘', delivery: '2–5 j', freeFrom: 100,   returns: 14  },
  hm:           { name: 'H&M',           color: '#E50010', bg: '#FFF0F0', logo: '🔴', delivery: '3–5 j', freeFrom: 0,     returns: 30  },
  mango:        { name: 'Mango',         color: '#8C6039', bg: '#F9F5F1', logo: '🟤', delivery: '3–5 j', freeFrom: 0,     returns: 30  },
  zara:         { name: 'Zara',          color: '#1A1A1A', bg: '#F5F5F5', logo: '⬛', delivery: '2–5 j', freeFrom: 50,    returns: 30  },
  sezane:       { name: 'Sézane',        color: '#4A3820', bg: '#F5EFE8', logo: '🪡', delivery: '3–7 j', freeFrom: 0,     returns: 30  },
};

/* ─── Catalogue enrichi ─────────────────────────────────────── */
export const CATALOG = [

  /* ══ ZALANDO ══════════════════════════════════════════════ */
  {
    id: 'zal_001', gender: 'F', partner: 'zalando', category: 'Robes',
    name: 'Robe midi plissée satin', brand: 'Vero Moda',
    price: 89, originalPrice: 89, discount: null,
    color: 'Noir', colors: ['Noir', 'Ivoire', 'Bordeaux'],
    sizes: ['34','36','38','40','42'],
    emoji: '👗',
    image: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&q=80',
    images: [
      'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&q=80',
      'https://images.unsplash.com/photo-1566479179817-c0c3c3b88b34?w=400&q=80',
    ],
    available: true,
    rating: 4.3, reviews: 128,
    description: 'Robe midi élégante en satin plissé. Coupe fluide, idéale pour les soirées.',
    composition: '100% Polyester recyclé',
    occasions: ['soiree', 'diner'],
    styles: ['Chic', 'Soirée'],
    aiCompatible: ['w2', 'w3', 'w6', 'w9'],
  },
  {
    id: 'zal_002', gender: 'F', partner: 'zalando', category: 'Chaussures',
    name: 'Escarpins aiguille cuir', brand: 'Anna Field',
    price: 65, originalPrice: 85, discount: 24,
    color: 'Nude', colors: ['Nude', 'Noir', 'Rouge'],
    sizes: ['36','37','38','39','40','41'],
    emoji: '👠',
    image: 'https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=400&q=80'],
    available: true,
    rating: 4.5, reviews: 342,
    description: 'Escarpins à talon aiguille 8 cm. Semelle intérieure rembourrée pour plus de confort.',
    composition: 'Tige : cuir synthétique',
    occasions: ['soiree', 'diner', 'work'],
    styles: ['Soirée', 'Chic', 'Bureau'],
    aiCompatible: ['w1', 'w4', 'w7'],
  },
  {
    id: 'zal_003', gender: 'F', partner: 'zalando', category: 'Sacs',
    name: 'Sac cabas cuir camel', brand: 'Even&Odd',
    price: 59, originalPrice: 59, discount: null,
    color: 'Camel', colors: ['Camel', 'Noir', 'Cognac'],
    sizes: ['Unique'],
    emoji: '👜',
    image: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=400&q=80'],
    available: true,
    rating: 4.1, reviews: 89,
    description: 'Sac cabas spacieux en simili cuir. Fermeture zippée, anse longue amovible.',
    occasions: ['work', 'sortie', 'casual'],
    styles: ['Bureau', 'Casual'],
    aiCompatible: ['w2', 'w4', 'w11'],
  },
  {
    id: 'zal_004', gender: 'F', partner: 'zalando', category: 'Vestes',
    name: 'Blazer oversize beige', brand: 'Selected',
    price: 119, originalPrice: 149, discount: 20,
    color: 'Beige', colors: ['Beige', 'Noir', 'Gris'],
    sizes: ['34','36','38','40','42','44'],
    emoji: '🧥',
    image: 'https://images.unsplash.com/photo-1594938298603-c8148c4b4571?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1594938298603-c8148c4b4571?w=400&q=80'],
    available: true,
    rating: 4.6, reviews: 215,
    description: 'Blazer oversize coupe structurée. Le must-have de la saison pour un look bureau ou casual chic.',
    occasions: ['work', 'sortie', 'casual'],
    styles: ['Chic', 'Bureau', 'Casual'],
    aiCompatible: ['w4', 'w8', 'w13'],
  },

  /* ══ ASOS ══════════════════════════════════════════════════ */
  {
    id: 'asos_001', gender: 'F', partner: 'asos', category: 'Chaussures',
    name: 'Sneakers cuir blanc premium', brand: 'ASOS Design',
    price: 55, originalPrice: 55, discount: null,
    color: 'Blanc', colors: ['Blanc', 'Noir', 'Beige'],
    sizes: ['36','37','38','39','40','41','42'],
    emoji: '👟',
    image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&q=80'],
    available: true,
    rating: 4.4, reviews: 567,
    description: 'Sneakers en cuir véritable, semelle épaisse. Polyvalentes et intemporelles.',
    occasions: ['casual', 'sortie'],
    styles: ['Casual', 'Streetwear'],
    aiCompatible: ['w4', 'w11', 'w13'],
  },
  {
    id: 'asos_002', gender: 'F', partner: 'asos', category: 'Bijoux',
    name: 'Collier chaîne dorée fine', brand: 'ASOS Design',
    price: 18, originalPrice: 18, discount: null,
    color: 'Or', colors: ['Or', 'Argent'],
    sizes: ['Unique'],
    emoji: '💍',
    image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=400&q=80'],
    available: true,
    rating: 4.2, reviews: 234,
    description: 'Collier chaîne minimaliste plaqué or. Longueur réglable de 40 à 45 cm.',
    occasions: ['soiree', 'diner', 'casual'],
    styles: ['Chic', 'Casual', 'Soirée'],
    aiCompatible: ['w1', 'w7', 'w11'],
  },
  {
    id: 'asos_003', gender: 'F', partner: 'asos', category: 'Vestes',
    name: 'Trench coat classique beige', brand: 'ASOS Design',
    price: 89, originalPrice: 110, discount: 19,
    color: 'Beige', colors: ['Beige', 'Kaki', 'Noir'],
    sizes: ['34','36','38','40','42'],
    emoji: '🧥',
    image: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=400&q=80'],
    available: true,
    rating: 4.5, reviews: 389,
    description: 'Trench intemporel double boutonnage. Ceinture à nouer, col rabattu.',
    occasions: ['sortie', 'work', 'casual'],
    styles: ['Chic', 'Bureau', 'Casual'],
    aiCompatible: ['w4', 'w8', 'w13'],
  },
  {
    id: 'asos_004', gender: 'F', partner: 'asos', category: 'Robes',
    name: 'Robe wrap fleurie', brand: 'ASOS Design',
    price: 45, originalPrice: 60, discount: 25,
    color: 'Multicolore', colors: ['Multicolore'],
    sizes: ['34','36','38','40','42','44'],
    emoji: '🌸',
    image: 'https://images.unsplash.com/photo-1612722432474-b971cdcea546?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1612722432474-b971cdcea546?w=400&q=80'],
    available: false, // en rupture
    rating: 4.3, reviews: 156,
    description: 'Robe portefeuille à imprimé fleuri. Idéale pour le printemps-été.',
    occasions: ['casual', 'sortie', 'diner'],
    styles: ['Bohème', 'Casual'],
    aiCompatible: ['w3', 'w5'],
  },

  /* ══ NET-A-PORTER ══════════════════════════════════════════ */
  {
    id: 'nap_001', gender: 'F', partner: 'net_a_porter', category: 'Robes',
    name: 'Robe de soirée en satin', brand: 'Saint Laurent',
    price: 1850, originalPrice: 1850, discount: null,
    color: 'Noir', colors: ['Noir', 'Ivoire'],
    sizes: ['34','36','38','40'],
    emoji: '✨',
    image: 'https://images.unsplash.com/photo-1623609163859-ca93c959b98a?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1623609163859-ca93c959b98a?w=400&q=80'],
    available: true,
    rating: 4.9, reviews: 28,
    description: 'Robe couture en satin de soie. Coupe fourreau, fente latérale. Pièce signature.',
    occasions: ['soiree'],
    styles: ['Luxe', 'Soirée'],
    aiCompatible: ['w3', 'w6', 'w9'],
  },
  {
    id: 'nap_002', gender: 'F', partner: 'net_a_porter', category: 'Sacs',
    name: 'Pochette clutch dorée', brand: 'Jimmy Choo',
    price: 695, originalPrice: 695, discount: null,
    color: 'Or', colors: ['Or', 'Argent'],
    sizes: ['Unique'],
    emoji: '👛',
    image: 'https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?w=400&q=80'],
    available: true,
    rating: 4.8, reviews: 42,
    description: 'Pochette minaudière dorée avec détail strass. Chaîne amovible.',
    occasions: ['soiree', 'diner'],
    styles: ['Luxe', 'Soirée'],
    aiCompatible: ['w1', 'w7'],
  },
  {
    id: 'nap_003', gender: 'F', partner: 'net_a_porter', category: 'Accessoires',
    name: 'Lunettes cat-eye tortoise', brand: 'Gucci',
    price: 340, originalPrice: 340, discount: null,
    color: 'Marron', colors: ['Marron', 'Noir'],
    sizes: ['Unique'],
    emoji: '🕶️',
    image: 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=400&q=80'],
    available: true,
    rating: 4.7, reviews: 63,
    description: 'Monture écaille effet tortoise, verres UV400. Livré avec étui en cuir.',
    occasions: ['casual', 'sortie', 'soiree'],
    styles: ['Luxe', 'Chic'],
    aiCompatible: ['w1', 'w2', 'w7'],
  },

  /* ══ H&M ═══════════════════════════════════════════════════ */
  {
    id: 'hm_001', gender: 'F', partner: 'hm', category: 'Hauts',
    name: 'Top en lin écru', brand: 'H&M',
    price: 24, originalPrice: 24, discount: null,
    color: 'Écru', colors: ['Écru', 'Blanc', 'Noir', 'Bleu'],
    sizes: ['XS','S','M','L','XL'],
    emoji: '👚',
    image: 'https://images.unsplash.com/photo-1562157873-818bc0726f68?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1562157873-818bc0726f68?w=400&q=80'],
    available: true,
    rating: 4.0, reviews: 892,
    description: 'Top en lin doux et respirant. Coupe droite, col rond, manches courtes.',
    occasions: ['casual', 'sortie'],
    styles: ['Casual', 'Bohème'],
    aiCompatible: ['w4', 'w8', 'w13'],
  },
  {
    id: 'hm_002', gender: 'F', partner: 'hm', category: 'Bas',
    name: 'Jean slim taille haute', brand: 'H&M',
    price: 35, originalPrice: 35, discount: null,
    color: 'Bleu', colors: ['Bleu', 'Noir', 'Gris'],
    sizes: ['34','36','38','40','42','44'],
    emoji: '👖',
    image: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&q=80'],
    available: true,
    rating: 4.2, reviews: 1234,
    description: 'Jean slim taille haute en denim stretch. 5 poches, fermeture boutonnée.',
    occasions: ['casual', 'sortie', 'work'],
    styles: ['Casual', 'Chic'],
    aiCompatible: ['w2', 'w5', 'w8', 'w11'],
  },
  {
    id: 'hm_003', gender: 'F', partner: 'hm', category: 'Accessoires',
    name: 'Ceinture tressée camel', brand: 'H&M',
    price: 19, originalPrice: 19, discount: null,
    color: 'Camel', colors: ['Camel', 'Noir'],
    sizes: ['S/M', 'M/L'],
    emoji: '🪢',
    image: 'https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=400&q=80'],
    available: true,
    rating: 4.1, reviews: 445,
    description: 'Ceinture tressée en simili cuir avec boucle dorée.',
    occasions: ['casual', 'sortie', 'work'],
    styles: ['Casual', 'Bohème'],
    aiCompatible: ['w4', 'w7', 'w13'],
  },

  /* ══ MANGO ══════════════════════════════════════════════════ */
  {
    id: 'mng_001', gender: 'F', partner: 'mango', category: 'Vestes',
    name: 'Blazer structuré écru', brand: 'Mango',
    price: 79, originalPrice: 99, discount: 20,
    color: 'Écru', colors: ['Écru', 'Noir', 'Camel'],
    sizes: ['34','36','38','40','42'],
    emoji: '🧥',
    image: 'https://images.unsplash.com/photo-1594938298603-c8148c4b4571?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1594938298603-c8148c4b4571?w=400&q=80'],
    available: true,
    rating: 4.4, reviews: 312,
    description: 'Blazer à revers cranté, coupe structurée. Doublure légère, bouton doré.',
    occasions: ['work', 'sortie', 'diner'],
    styles: ['Bureau', 'Chic'],
    aiCompatible: ['w4', 'w8', 'w13'],
  },
  {
    id: 'mng_002', gender: 'F', partner: 'mango', category: 'Chaussures',
    name: 'Mules à talon carré', brand: 'Mango',
    price: 49, originalPrice: 49, discount: null,
    color: 'Marron', colors: ['Marron', 'Noir', 'Beige'],
    sizes: ['36','37','38','39','40','41'],
    emoji: '👡',
    image: 'https://images.unsplash.com/photo-1551107696-a4b0c5a0d9a2?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1551107696-a4b0c5a0d9a2?w=400&q=80'],
    available: true,
    rating: 4.3, reviews: 198,
    description: 'Mules ouvertes talon carré 6 cm en simili cuir. Bout carré tendance.',
    occasions: ['casual', 'sortie', 'diner'],
    styles: ['Chic', 'Casual'],
    aiCompatible: ['w7', 'w11', 'w4'],
  },
  {
    id: 'mng_003', gender: 'F', partner: 'mango', category: 'Robes',
    name: 'Robe chemise en satin', brand: 'Mango',
    price: 69, originalPrice: 69, discount: null,
    color: 'Bordeaux', colors: ['Bordeaux', 'Noir', 'Vert'],
    sizes: ['34','36','38','40','42'],
    emoji: '👗',
    image: 'https://images.unsplash.com/photo-1566479179817-c0c3c3b88b34?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1566479179817-c0c3c3b88b34?w=400&q=80'],
    available: true,
    rating: 4.5, reviews: 267,
    description: 'Robe chemise boutonnée en satin. Col classique, ceinture à nouer.',
    occasions: ['diner', 'sortie', 'work'],
    styles: ['Chic', 'Bureau'],
    aiCompatible: ['w3', 'w9'],
  },

  /* ══ FARFETCH ═══════════════════════════════════════════════ */
  {
    id: 'far_001', gender: 'F', partner: 'farfetch', category: 'Accessoires',
    name: 'Écharpe cashmere camel', brand: 'Toteme',
    price: 280, originalPrice: 280, discount: null,
    color: 'Camel', colors: ['Camel', 'Ivoire', 'Gris'],
    sizes: ['Unique'],
    emoji: '🧣',
    image: 'https://images.unsplash.com/photo-1601924582970-9238bcb495d9?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1601924582970-9238bcb495d9?w=400&q=80'],
    available: true,
    rating: 4.8, reviews: 73,
    description: 'Écharpe en pure laine cashmere écossais. Dimensions 180 x 50 cm.',
    occasions: ['casual', 'sortie', 'work'],
    styles: ['Chic', 'Casual'],
    aiCompatible: ['w2', 'w12'],
  },
  {
    id: 'far_002', gender: 'F', partner: 'farfetch', category: 'Sacs',
    name: 'Mini sac shoulder quilté', brand: 'Bottega Veneta',
    price: 1250, originalPrice: 1250, discount: null,
    color: 'Noir', colors: ['Noir', 'Ivoire'],
    sizes: ['Unique'],
    emoji: '👜',
    image: 'https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?w=400&q=80'],
    available: true,
    rating: 4.9, reviews: 34,
    description: 'Mini sac en cuir intrecciato. Bandoulière fine amovible, fermeture magnétique.',
    occasions: ['soiree', 'diner'],
    styles: ['Luxe', 'Soirée'],
    aiCompatible: ['w1', 'w7'],
  },
  /* ══ H&M HOMME ═══════════════════════════════════════════ */
  {
    id: 'hm_m001', partner: 'hm', category: 'Hauts', gender: 'M',
    name: 'Chemise oxford slim', brand: 'H&M',
    price: 29, originalPrice: 29, discount: null,
    color: 'Blanc', colors: ['Blanc', 'Bleu', 'Gris'],
    sizes: ['S','M','L','XL','XXL'],
    emoji: '👔',
    image: 'https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=400&q=80'],
    available: true, rating: 4.2, reviews: 456,
    description: 'Chemise slim fit en popeline de coton. Col boutonné.',
    occasions: ['work','sortie','casual'], styles: ['Bureau','Casual'],
  },
  {
    id: 'hm_m002', partner: 'hm', category: 'Bas', gender: 'M',
    name: 'Chino slim beige', brand: 'H&M',
    price: 39, originalPrice: 39, discount: null,
    color: 'Beige', colors: ['Beige', 'Noir', 'Kaki'],
    sizes: ['28','30','32','34','36'],
    emoji: '👖',
    image: 'https://images.unsplash.com/photo-1473966968600-fa801b869a1a?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1473966968600-fa801b869a1a?w=400&q=80'],
    available: true, rating: 4.1, reviews: 389,
    description: 'Pantalon chino slim en coton stretch.',
    occasions: ['work','sortie','casual'], styles: ['Bureau','Casual'],
  },

  /* ══ ZARA HOMME ════════════════════════════════════════════ */
  {
    id: 'zara_m001', partner: 'zara', category: 'Vestes', gender: 'M',
    name: 'Blazer structuré navy', brand: 'Zara',
    price: 89, originalPrice: 119, discount: 25,
    color: 'Marine', colors: ['Marine', 'Gris', 'Noir'],
    sizes: ['S','M','L','XL'],
    emoji: '🧥',
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=400&q=80'],
    available: true, rating: 4.5, reviews: 287,
    description: 'Blazer structuré coupe slim. Doublure légère, boutons dorés.',
    occasions: ['work','diner','sortie'], styles: ['Bureau','Chic'],
  },
  {
    id: 'zara_m002', partner: 'zara', category: 'Chaussures', gender: 'M',
    name: 'Derby cuir lisse noir', brand: 'Zara',
    price: 79, originalPrice: 79, discount: null,
    color: 'Noir', colors: ['Noir', 'Marron'],
    sizes: ['40','41','42','43','44','45'],
    emoji: '👞',
    image: 'https://images.unsplash.com/photo-1449505278894-297fdb3edbc1?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1449505278894-297fdb3edbc1?w=400&q=80'],
    available: true, rating: 4.3, reviews: 198,
    description: 'Derby en cuir lisse. Semelle en cuir, lacets plats.',
    occasions: ['work','diner','soiree'], styles: ['Bureau','Chic','Soirée'],
  },

  /* ══ ZALANDO HOMME ════════════════════════════════════════ */
  {
    id: 'zal_m001', partner: 'zalando', category: 'Hauts', gender: 'M',
    name: 'T-shirt col rond premium', brand: 'Selected',
    price: 35, originalPrice: 35, discount: null,
    color: 'Blanc', colors: ['Blanc', 'Noir', 'Gris', 'Marine'],
    sizes: ['S','M','L','XL','XXL'],
    emoji: '👕',
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&q=80'],
    available: true, rating: 4.4, reviews: 512,
    description: 'T-shirt premium en coton pima. Coupe regular.',
    occasions: ['casual','sortie'], styles: ['Casual','Streetwear'],
  },
  {
    id: 'zal_m002', partner: 'zalando', category: 'Chaussures', gender: 'M',
    name: 'Sneakers cuir blanc', brand: 'Tommy Hilfiger',
    price: 95, originalPrice: 120, discount: 21,
    color: 'Blanc', colors: ['Blanc', 'Noir'],
    sizes: ['40','41','42','43','44','45'],
    emoji: '👟',
    image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&q=80'],
    available: true, rating: 4.6, reviews: 743,
    description: 'Sneakers en cuir lisse avec semelle épaisse.',
    occasions: ['casual','sortie'], styles: ['Casual','Streetwear'],
  },
  {
    id: 'zal_m003', partner: 'zalando', category: 'Accessoires', gender: 'M',
    name: 'Montre minimaliste argent', brand: 'Fossil',
    price: 119, originalPrice: 149, discount: 20,
    color: 'Argent', colors: ['Argent', 'Or'],
    sizes: ['Unique'],
    emoji: '⌚',
    image: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&q=80'],
    available: true, rating: 4.7, reviews: 334,
    description: 'Montre à quartz minimaliste, bracelet en acier.',
    occasions: ['work','soiree','casual'], styles: ['Chic','Bureau'],
  },

  /* ══ ASOS HOMME ═══════════════════════════════════════════ */
  {
    id: 'asos_m001', partner: 'asos', category: 'Vestes', gender: 'M',
    name: 'Bomber oversize kaki', brand: 'ASOS Design',
    price: 65, originalPrice: 65, discount: null,
    color: 'Kaki', colors: ['Kaki', 'Noir', 'Beige'],
    sizes: ['S','M','L','XL'],
    emoji: '🧥',
    image: 'https://images.unsplash.com/photo-1551537482-f2075a1d41f2?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1551537482-f2075a1d41f2?w=400&q=80'],
    available: true, rating: 4.3, reviews: 267,
    description: 'Bomber oversize en nylon léger. Col montant, poches zippées.',
    occasions: ['casual','sortie'], styles: ['Casual','Streetwear'],
  },
  {
    id: 'asos_m002', partner: 'asos', category: 'Bas', gender: 'M',
    name: 'Jean skinny noir', brand: 'ASOS Design',
    price: 45, originalPrice: 55, discount: 18,
    color: 'Noir', colors: ['Noir', 'Bleu'],
    sizes: ['28','30','32','34','36'],
    emoji: '👖',
    image: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&q=80'],
    available: true, rating: 4.2, reviews: 589,
    description: 'Jean skinny en denim stretch. 5 poches, coupe ajustée.',
    occasions: ['casual','sortie'], styles: ['Casual','Streetwear'],
  },
];

/* ─── Helpers ──────────────────────────────────────────────── */

export function getCatalogByGender(gender) {
  if (!gender || gender === 'N') return CATALOG;
  return CATALOG.filter(p => p.gender === gender || p.gender === 'N' || !p.gender);
}

export function getCatalogByPartner(partnerId) {
  return CATALOG.filter(p => p.partner === partnerId);
}

export function getCatalogByCategory(category) {
  return CATALOG.filter(p => p.category === category);
}

export function searchCatalog(query) {
  const q = query.toLowerCase();
  return CATALOG.filter(p =>
    p.name.toLowerCase().includes(q) ||
    p.brand.toLowerCase().includes(q) ||
    p.category.toLowerCase().includes(q) ||
    p.color.toLowerCase().includes(q)
  );
}

export function getCompatibleProducts(wardrobeItemIds) {
  return CATALOG.filter(p =>
    p.available &&
    p.aiCompatible?.some(id => wardrobeItemIds.includes(id))
  );
}

// v1.12.204 — 'Manteaux' ajouté entre Vestes et Bas (long > mi-cuisse)
export const CATALOG_CATEGORIES = ['Tout', 'Robes', 'Hauts', 'Vestes', 'Manteaux', 'Bas', 'Chaussures', 'Sacs', 'Accessoires', 'Bijoux'];
export const CATALOG_PARTNERS   = ['Tout', ...Object.keys(PARTNERS_INFO)];
export const PRICE_RANGES       = [
  { label: 'Tout', max: null },
  { label: '< 50 €',  max: 50   },
  { label: '< 100 €', max: 100  },
  { label: '< 200 €', max: 200  },
  { label: '200 €+',  min: 200  },
];
